import React, { useState } from 'react';
import Logo from './Logo';

const Header: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  
  const navLinks = [
    { label: "About", id: "about" },
    { label: "Why JSkool?", id: "whyjskool" },
    { label: "Programs", id: "programs" },
    { label: "Team", id: "team" },
    { label: "Inspiration", id: "inspiration" },
    { label: "AI Guru", id: "/jskool-gpt" },
    { label: "Play Online Games", id: "/games"},
    { label: "Join Us", id: "joinus" }
  ];

  const handleNavClick = (id: string) => {
    if (id.startsWith('/')) {
        window.location.href = id;
    } else {
        // If we are not on the homepage, first navigate there
        if (window.location.pathname !== '/') {
            window.location.href = '/#' + id;
        } else {
            const section = document.getElementById(id);
            if (section) {
                section.scrollIntoView({ behavior: 'smooth' });
            }
        }
    }
    setIsOpen(false);
  };
  
  const renderLink = (link: {label: string, id: string}) => {
    const className = "font-heading font-bold text-lg text-jskool-dark hover:text-jskool-blue transition-colors duration-300 w-full text-center py-2 md:w-auto md:py-0 md:text-left";
    if (link.id.startsWith('/')) {
        return <a key={link.id} href={link.id} className={className}>{link.label}</a>
    }
    return <button key={link.id} onClick={() => handleNavClick(link.id)} className={className}>{link.label}</button>
  }

  return (
    <header className="bg-jskool-cream/80 backdrop-blur-md sticky top-0 z-50 shadow-md">
      <div className="container mx-auto px-6 py-3 flex justify-between items-center">
        <a href="/" className="flex items-center cursor-pointer">
           <Logo className="h-12" />
        </a>
        <nav className="hidden md:flex items-center space-x-6">
          {navLinks.map(link => renderLink(link))}
        </nav>
        <div className="md:hidden">
          <button onClick={() => setIsOpen(!isOpen)} className="text-jskool-dark focus:outline-none">
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d={isOpen ? "M6 18L18 6M6 6l12 12" : "M4 6h16M4 12h16m-7 6h7"}></path>
            </svg>
          </button>
        </div>
      </div>
      {isOpen && (
        <div className="md:hidden bg-jskool-cream shadow-lg">
          <nav className="flex flex-col items-center py-4">
            {navLinks.map(link => renderLink(link))}
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;
